module.exports = __webpack_public_path__ + "img/image1.788f84b0.png";